import {DataFetcher} from '@aboutyou/data-fetcher';
import {GetSearchResultsPageBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/search/v1/service.types';
import {useTranslation} from '@aboutyou/i18n';
import React from 'react';
import {
  StreamHeader,
  StreamHeaderProps,
} from '../../../features/StreamHeader/StreamHeader';
import {StreamHeaderLoading} from '../../../features/StreamHeader/StreamHeaderLoading';
import {useSearchPageFiltersSection} from '../hooks/useSearchPageBulkSection';
import {useSearchTerm} from '../hooks/useSearchTerm';

export const SearchStreamHeader: React.FC<StreamHeaderProps> = props => {
  return (
    <DataFetcher
      request={useSearchPageFiltersSection()}
      Error={null}
      Loading={StreamHeaderLoading}
      viewProps={props}
      View={View}
    />
  );
};

const View: React.FC<
  GetSearchResultsPageBulkResponse['filters'] & StreamHeaderProps
> = props => {
  const term = useSearchTerm();
  const {t} = useTranslation();

  const adjustedTerm = term.length > 25 ? `${term.slice(0, 25)}…` : term;

  const title = t('Your search for {term}', {term: `“${adjustedTerm}”`});

  return <StreamHeader hideProductCount {...props} title={title} />;
};
